module.exports = __webpack_public_path__ + "static/media/icon-trash.d86063c7.svg";